import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=57478973&scoped=true&"
import script from "./teacherList.vue?vue&type=script&lang=js&"
export * from "./teacherList.vue?vue&type=script&lang=js&"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=57478973&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57478973",
  null
  
)

export default component.exports